import React, { useEffect, useRef } from 'react';
import { Button } from './ui/button';
import { CalendarDays } from 'lucide-react';

const CSS_HREF = 'https://calendar.google.com/calendar/scheduling-button-script.css';
const SCRIPT_SRC = 'https://calendar.google.com/calendar/scheduling-button-script.js';
const SCHEDULE_URL = 'https://calendar.google.com/calendar/appointments/schedules/AcZssZ2KJpLUbNfx9Rn5LLj_LevmJRFYDo2CJEVMO42G5ujNuWCAEWC37rRAembQlRhJVhd-Fji83-wV?gv=true';

const loadSchedulingScript = () => {
  if (!document.querySelector(`link[href="${CSS_HREF}"]`)) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = CSS_HREF;
    document.head.appendChild(link);
  }

  if (window.__gcalSchedulingPromise) return window.__gcalSchedulingPromise;

  window.__gcalSchedulingPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });

  return window.__gcalSchedulingPromise;
};

const BookAppointmentButton = ({ className = '', size = 'default', label = 'Book an Appointment', testId = 'book-appointment-btn' }) => {
  const targetRef = useRef(null);
  const hostRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    loadSchedulingScript()
      .then(() => {
        if (cancelled || !targetRef.current || !window.calendar?.schedulingButton) return;
        window.calendar.schedulingButton.load({
          url: SCHEDULE_URL,
          color: '#039BE5',
          label,
          target: targetRef.current,
        });
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [label]);

  const openScheduler = () => {
    if (window.gtag) {
      window.gtag('event', 'cta_click', {
        event_category: 'Engagement',
        event_label: 'Book an Appointment',
        value: 1,
      });
    }
    if (window.fbq) {
      window.fbq('track', 'Schedule');
    }

    const googleButton = hostRef.current?.querySelector('button, [role="button"], a');
    if (googleButton) {
      googleButton.click();
    } else {
      window.open(SCHEDULE_URL, '_blank', 'noopener,noreferrer,width=700,height=750');
    }
  };

  return (
    <>
      <Button
        type="button"
        size={size}
        onClick={openScheduler}
        data-testid={testId}
        className={`bg-gradient-to-r from-cyan-500 to-teal-600 hover:from-cyan-600 hover:to-teal-700 text-white shadow-lg hover:shadow-xl transition-all duration-300 ${className}`}
      >
        <CalendarDays className="w-4 h-4 mr-2" />
        {label}
      </Button>
      {/* Google Calendar Appointment Scheduling (button injected here, kept hidden) */}
      <span ref={hostRef} className="sr-only" aria-hidden="true">
        <span ref={targetRef} />
      </span>
    </>
  );
};

export default BookAppointmentButton;
